import { SkillProgression } from "@/features/progression/components/SkillProgression";

export function ProgressPage() {
    return <SkillProgression />;
}

